<div class="trophy-icon" [ngClass]="{'hidden-type': trophy.status === GameTrophyStatus.HIDDEN && !isCompleted}" [attr.data-id]="trophy.id">
  <div class="trophy-icon__icon-background">
    <img [src]="backgroundSrc" [alt]="trophy.name">
  </div>
  <div class="trophy-icon__icon-foreground">
    <img [src]="trophyIconPath" [alt]="trophy.name">
    <brt-icon [icon]="'med'"></brt-icon>
  </div>
</div>
